module.exports = __webpack_public_path__ + "static/assets/c9317cb84136a857ad8360458e42aa0b.svg";